<div class="footer app-inner-padding">{{ 'connectionsModal.graphicElement.qrCode' | translate }}</div>
